import React from 'react';
import { Card } from 'react-bootstrap';

/**
 * Leer- und Fehlerzustands-Komponente.
 * Zeigt kontextsensitive Platzhalter-Nachrichten f&uuml;r:
 * - Keine Daten vorhanden
 * - Zu wenige Jahre f&uuml;r Trendanalyse
 * - Backend nicht erreichbar (Fehler)
 * - Ladeanimation
 *
 * @param {object} props
 * @param {string}   props.state    – 'loading' | 'keineDaten' | 'zuWenigeJahre' | 'fehler'
 * @param {string}   [props.message] – optionale Detailnachricht
 * @param {function} [props.onRetry] – Callback f&uuml;r Wiederholen-Button (bei 'fehler')
 */
const EmptyState = ({ state, message, onRetry }) => {
    const configs = {
        loading: {
            icon: 'bi-sun',
            animation: 'spin',
            title: 'Lade Jahresvergleich&hellip;',
            text: 'Daten werden vom Server abgerufen.',
            alert: null,
        },
        keineDaten: {
            icon: 'bi-database-x',
            animation: '',
            title: 'Keine Daten verf&uuml;gbar',
            text: message
                || 'Es liegen keine historischen Ertragsdaten vor.',
            alert: 'warning',
        },
        zuWenigeJahre: {
            icon: 'bi-calendar2-x',
            animation: '',
            title: 'Zu wenige Jahre f&uuml;r Trendanalyse',
            text: message
                || 'Die Trendanalyse ben&ouml;tigt mindestens 3 vollst&auml;ndige Jahre.',
            alert: 'warning',
        },
        fehler: {
            icon: 'bi-exclamation-triangle',
            animation: '',
            title: 'Fehler beim Abrufen der Daten',
            text: message || 'Der Server konnte nicht erreicht werden.',
            alert: 'danger',
        },
    };

    var cfg = configs[state] || configs.keineDaten;

    if (state === 'loading') {
        return (
            <div className="loader-message">
                <i className={`bi ${cfg.icon} spin-icon me-2`} />
                {cfg.title}
            </div>
        );
    }

    return (
        <Card className="mb-3 empty-state-card mt-3">
            <Card.Body className="text-center py-4">
                <i className={`bi ${cfg.icon} mb-3 d-block`} style={{ fontSize: '2rem' }} />
                <h5>{cfg.title}</h5>
                <p className="text-muted mb-3">{cfg.text}</p>
                {onRetry && (
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={onRetry}
                    >
                        <i className="bi bi-arrow-repeat me-1" />
                        Wiederholen
                    </button>
                )}
            </Card.Body>
        </Card>
    );
};

export default EmptyState;
